import { IPrintRecord, PrintSlices, SectionSelectors } from "./index";
import { cropCanvas } from "@/util/helpers";

export class PrintRecord implements IPrintRecord {
  canvas!: HTMLCanvasElement;
  $el!: HTMLElement;
  name!: string;
  scale!: number;
  selectors!: SectionSelectors;
  slices!: PrintSlices;
  cropIndex = -1;

  constructor(data: PrintRecord | IPrintRecord) {
    if (data instanceof PrintRecord) {
      return data;
    }
    Object.assign(this, { ...data });
  }

  get header(): HTMLCanvasElement | null {
    return this.slices.header
      ? cropCanvas(this.canvas, 0, 0, this.canvas.width, this.slices.header)
      : null;
  }

  get body(): HTMLCanvasElement {
    return cropCanvas(
      this.canvas,
      0,
      this.slices.header,
      this.canvas.width,
      this.slices.breaks[this.slices.breaks.length - 1] - this.slices.header
    );
  }

  crop(from: number, to: number): HTMLCanvasElement {
    return cropCanvas(
      this.canvas,
      0,
      this.cropPosition(from),
      this.canvas.width,
      this.cropPosition(to) - this.cropPosition(from)
    );
  }

  get breakPoints(): number[] {
    return [
      ...new Set([...(this.slices?.breaks || []), this.canvas.height]),
    ].filter(
      (item, key) =>
        item !== this.slices.header &&
        (key || this.selectors?.breakPosition !== "top")
    );
  }

  cropPosition(index: number) {
    if (index === -1) {
      return this.slices.header;
    } else {
      return this.breakPoints[index] || this.canvas.height;
    }
  }
}
